// extracted by mini-css-extract-plugin
export default {"btn-container":"FileUploaderModal_btn-container__HDahm","proceed":"FileUploaderModal_proceed__6G7g8","cancel":"FileUploaderModal_cancel__RfbUA"};